import { TranslationLocales } from './';

type ITranslationFunction = {
  [key in YadoTranslationKeys]: ({}?: { [arg: string]: string|number }) => string;
}

export type YadoTranslationKeys =
'whichRoomType'|
'cancellationNoShow'|
'cancellationXDaysBefore'|
'cancellationOnTheDay';

type YadoRoomTypeKeys =
'double'|
'four_bed'|
'others'|
'semi_double'|
'single'|
'triple'|
'twin'|
'japanese_style_room'|
'japanese_western_style_room';

const whichRoomType = (roomType: YadoRoomTypeKeys, locale: TranslationLocales) => (
  {
    'en': {
      double: 'Double room',
      four_bed: 'Quadruple-bedded room',
      others: 'Others',
      semi_double: 'Room with three-quarter bed',
      single: 'Single room',
      triple: 'Triple-bedded room',
      twin: 'Twin-bedded room',
      japanese_style_room: 'Japanese style room',
      japanese_western_style_room: 'Japanese/Western hybrid style room',
    },
    'ja': {
      double: 'ダブル',
      four_bed: '4ベッド',
      others: 'その他',
      semi_double: 'セミダブル',
      single: 'シングル',
      triple: 'トリプル',
      twin: 'ツイン',
      japanese_style_room: '和室',
      japanese_western_style_room: '和洋室',
    },
    'zh-CN': {
      double: '单床双人房',
      four_bed: '４人房',
      others: '其他',
      semi_double: '经济双人房',
      single: '单人房',
      triple: '三人房',
      twin: '双床双人房',
      japanese_style_room: '日式客房',
      japanese_western_style_room: '日式西式客房',
    },
    'zh-HK': {
      double: '單床雙人房',
      four_bed: '４人房',
      others: '其他',
      semi_double: '經濟雙人房',
      single: '單人房',
      triple: '三人房',
      twin: '雙床雙人房',
      japanese_style_room: '日式客房',
      japanese_western_style_room: '日式西式客房',
    },
    'zh-TW': {
      double: '單床雙人房',
      four_bed: '４人房',
      others: '其他',
      semi_double: '經濟雙人房',
      single: '單人房',
      triple: '三人房',
      twin: '雙床雙人房',
      japanese_style_room: '日式客房',
      japanese_western_style_room: '日式西式客房',
    },
  }[locale][roomType]
);

export const yadoTranslations: {
  [locale in TranslationLocales]: ITranslationFunction
} = {
  'en': {
    whichRoomType: ({ roomType }: { roomType: YadoRoomTypeKeys }) => whichRoomType(roomType, 'en'),
    cancellationNoShow: () => ('No contact'),
    cancellationXDaysBefore: ({ day }: { day: number }) => (`${day} days before`),
    cancellationOnTheDay: () => ('On the day'),
  },
  'ja': {
    whichRoomType: ({ roomType }: { roomType: YadoRoomTypeKeys }) => whichRoomType(roomType, 'ja'),
    cancellationNoShow: () => ('連絡なし'),
    cancellationXDaysBefore: ({ day }: { day: number }) => (`${day} 日前`),
    cancellationOnTheDay: () => ('当日'),
  },
  'zh-CN': {
    whichRoomType: ({ roomType }: { roomType: YadoRoomTypeKeys }) => whichRoomType(roomType, 'zh-CN'),
    cancellationNoShow: () => ('无联络'),
    cancellationXDaysBefore: ({ day }: { day: number }) => (`${day} 天前`),
    cancellationOnTheDay: () => ('当天'),
  },
  'zh-HK': {
    whichRoomType: ({ roomType }: { roomType: YadoRoomTypeKeys }) => whichRoomType(roomType, 'zh-HK'),
    cancellationNoShow: () => ('無聯絡'),
    cancellationXDaysBefore: ({ day }: { day: number }) => (`${day} 天前`),
    cancellationOnTheDay: () => ('當天'),
  },
  'zh-TW': {
    whichRoomType: ({ roomType }: { roomType: YadoRoomTypeKeys }) => whichRoomType(roomType, 'zh-TW'),
    cancellationNoShow: () => ('無聯絡'),
    cancellationXDaysBefore: ({ day }: { day: number }) => (`${day} 天前`),
    cancellationOnTheDay: () => ('當天'),
  },
};
